import * as moment from 'moment';
import { CalendarEvent } from "angular-calendar";
import { openingHourI, scheduleI } from 'app/core/interfaces/schedule';
import { flagI, paymentI } from 'app/core/interfaces/payment';
import { languageI, qualificationI, secretaryI } from 'app/core/interfaces/secretary';
import { practitionerI, prescriptionI } from 'app/core/interfaces/practitioner';
import { procedureI } from 'app/core/interfaces/procedure';
import { filterI, filterPractitionerI } from 'app/core/interfaces/filter';
import { patientI } from 'app/core/interfaces/patient';
import { cardColors } from './calendar.json';

export const scheduleHorarios:openingHourI[] = [];
for (var i = 1; i <= 7;i++) {
  for (var h = 9; h < 17;h++) { 
    if (h != 12) {
      scheduleHorarios.push({ dayOfWeek: i, timeStart: `0${h}:00`, timeEnd: `0${h}:30`  });
      scheduleHorarios.push({ dayOfWeek: i, timeStart: `0${h}:30`, timeEnd: `0${h+1}:00`  });
    }  
  }
};

export const flagsMock: flagI[] = [
    {
      id: 1,
      name: 'Visa',
      active: true,
      icon: 'card'
    },   
    {
      id: 2,
      name: 'Mastercard',
      active: true,
      icon: 'card'
    },   
    {
      id: 3,
      name: 'Elo',
      active: true,
      icon: 'card'
    },   
];

export const qualifications: qualificationI[] = [
  {
    id: 1,
    name: 'Secretariado',
    instituition: 'UNIASSELVI',
    dateConclusion: '2018-06-01',
    type: 'Bacharel'
  },
  {
    id: 2,
    name: 'Secretariado Executivo',
    instituition: 'UNIASSELVI',
    dateConclusion: '2020-06-01',
    type: 'Especialização'
  }
];

export const courses: qualificationI[] = [
  {
    id: 1,
    name: 'Secretária da Saúde',
    instituition: 'UNIASSELVI',
    dateConclusion: '2020-06-01'
  },
  {
    id: 2,
    name: 'Atendimento ao cliente',
    instituition: 'Sebrae',
    dateConclusion: '2021-06-01',
  }
];

export const languages: languageI[] = [
  {
    id: 1,
    name: 'Inglês',
    instituition: 'Wisdow',
    type: 'Avançado'
  },
  {
    id: 2,
    name: 'Alemão',
    instituition: 'ICBA',
    type: 'Intermediário'
  }
];

export const paymentMethodMock: paymentI[] = [
  {
    id: 1,
    name: 'A vista',
    active: true,
    icon: 'paid'
  },   
  {
    id: 2,
    name: 'Pix',
    active: true,
    icon: 'pix'
  },   
  {
    id: 3,
    name: 'Cartão de crédito',
    active: true,
    icon: 'credit_card',
    flags: [ flagsMock[0], flagsMock[1] ],
    conditions: [1,2,3,4,5,6,7,8,9,10]
  },   
];

export const addressMock: any[] = [
  {cep: '89035580', district: 'Vila Nova', street: 'Praça Arno Bernardes',
  city: 'Blumenau', complement: 'casa', state: 'SC', number: '100', country: 'Brasil',
  latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
  {cep: '89022005', district: 'Garcia', street: 'Praça Duque de Caxias',
  city: 'Blumenau', complement: 'apto. 68', state: 'SC', number: '100', country: 'Brasil',
  latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
  {cep: '89010005', district: 'Centro', street: 'Praça Governador Hercílio Luz',
  city: 'Blumenau', complement: 'apto. 50', state: 'SC', number: '100', country: 'Brasil',
  latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
  {cep: '89010005', district: 'Centro', street: 'Praça Governador Hercílio Luz',
  city: 'Blumenau', complement: 'apto. 50', state: 'SC', number: '100', country: 'Brasil',
  latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
  {cep: '89020403',  district: 'Centro', street: 'Praça Governador Hercílio Luz',
  city: 'Blumenau', complement: 'apto. 50', state: 'SC', number: '100', country: 'Brasil',
  latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
  {cep: '89020403',  district: 'Centro', street: 'Praça Governador Hercílio Luz',
  city: 'Blumenau', complement: 'apto. 50', state: 'SC', number: '100', country: 'Brasil',
  latitude: '-27.553777779913904', longitude: '-48.498534066204435' }
];


export const practitionersMock:any[] = [
  {
    id: "c86b2339-41da-4e91-9ddd-c0edee6a5913",
    name: 'Dr. Tibério',
    identifier: [
      {
        "system": "CPF",
        "value": "651599940-25"
      },
      {
        "system": "CRM",
        "value": "12345"
      }
    ],
    active: true,
    birthDate: '1990-05-21',
    cpf: '65159994025',
    gender: 'Male',
    crm: '12345',
    mail: 'tiberio@doutor.com.br',
    phone: '4733220011',
    mobile: '4799552277',
    avatar: "/assets/fotos/medico-1.png",
    specialty: 'Cardiologia',
    address: addressMock[0],
    languages: [ languages[0], languages[1] ],
    communication: [],
    value:'250,00'
  },
  {
    id:2,
    name: 'Ailton',
    identifier: [
      {
        "system": "CPF",
        "value": "331211730-57"
      },
      {
        "system": "CRM",
        "value": "58921"
      }
    ],
    active: true,
    birthDate: '1995-06-21',
    cpf: '33121173057',
    gender: 'Male',
    crm: '58921',
    mail: 'ailton@doutor.com.br',
    phone: '47334400221',
    mobile: '4799226377',
    avatar: "/assets/fotos/medico-2.png",
    address: addressMock[1],
    languages: [ languages[0], languages[1] ],
    communication: [],
    value:'350,00'
  },
  {
    id:3,
    name: 'Samuel',
    identifier: [
      {
        "system": "CPF",
        "value": "926799160-42"
      },
      {
        "system": "CRM",
        "value": "56417"
      }
    ],
    active: true,
    birthDate: '1964-04-21',
    cpf: '92679916042',
    gender: 'Female',
    crm: '56417',
    mail: 'samuel@doutor.com.br',
    phone: '4734400221',
    mobile: '47918752677',
    avatar: "/assets/fotos/medico-3.jpg",
    address: addressMock[2],
    languages: [ languages[0], languages[1] ],
    communication: [],
    value:'200,00'
  },
  {
    id:4,
    name: 'Beatriz',
    identifier: [
      {
        "system": "CPF",
        "value": "776155600-80"
      },
      {
        "system": "CRM",
        "value": "94171"
      }
    ],
    active: true,
    birthDate: '1995-06-21',
    cpf: '77615560080',
    gender: 'Female',
    crm: '94171',
    mail: 'beatriz@doutor.com.br',
    phone: '4734400221',
    mobile: '47918752677',
    avatar: "/assets/fotos/medico-4.jpg",
    address: addressMock[3],
    languages: [ languages[0], languages[1] ],
    communication: [],
    value:'300,00'
  }
];


export const organizationMock: any[] = [{
        id: "8ae7f7d1-f339-4d2e-a32d-4e6a1e90a6ba",
        name: 'Ritmo COR',
        identifier: [
          {
            "system": "CNPJ",
            "value": "41778965478-50"
          }
        ],
        alias: 'Hospital Santa Catarina',
        legal_representative: 'Ailton',
        cnpj: '123456789',
        mail: 'hsc@hsc.com.br',
        specialty: 'Cardiologia',
        mobile: '47992218844',
        phone: '4733382020',
        active: true,
        address: addressMock[4],
        schedule: [{
          dayOfWeek:1, 
          timeStart: '09:00', 
          timeEnd: '17:00'
      },
      {
          dayOfWeek:2, 
          timeStart: '08:00', 
          timeEnd: '13:00'
      }],
        status: 'completed'
    },
    {
        id: "d41d8cd98f00b204e9800998ecf8427e",
        name: 'Hospital Santo Antônio',
        alias: 'Hospital Santa Catarina',
        legal_representative: 'Tamiris',
        identifier: [
          {
            "system": "CNPJ",
            "value": "41778965478-50"
          }
        ],
        cnpj: '123456789',
        mail: 'hsa@hsa.com.br',
        specialty: 'Pediatria',
        mobile: '47992212255',
        phone: '4733342050',
        active: true,
        address: addressMock[5],
        schedule: [{
            dayOfWeek:1, 
            timeStart: '09:00', 
            timeEnd: '17:00'
        },
        {
            dayOfWeek:2, 
            timeStart: '09:00', 
            timeEnd: '17:00'
        }]  ,
        status: 'completed'    
    }
];

//descontinuado, versão antiga do backend
export const organizationList: any[] = [
    {
      organization_id: Math.floor(Math.random() * 1000) + 1,
      name: "Roger ndutiye",
      alias: "Roger",
      active: true,
      position: { altitude: 0.04, latitude: 2.25475478, longitude: -83.6945691  },
      identifier: [ 
        {system: "CNPJ", value: "774747477-1000"},
      ],
      hoursOfOperation: 
        { 
          daysOfWeek: ['mon', 'tue', 'fri'],
          allDay: false,
          openingTime: '09:00:00',
          closingTime: '16:30:00'
         }
      ,
      contact: [],
      telecom: [ 
        {system: "email", value: "rogerndutiye@gmail.com", use: "work" },
        {system: "phone", value: "250788841494", use: "work" }
      ]
    },
    {
      organization_id:Math.floor(Math.random() * 1000) + 1,
      name: "Unimed Vale",
      alias: "Unimed Vale",
      active: true,
      position: { altitude: 0.04, latitude: 2.25475478, longitude: -83.6945691  },
      identifier: [ 
        {system: "CNPJ", value: "774747477-1000"},
      ],
      hoursOfOperation: 
        { 
          daysOfWeek: ['mon', 'tue', 'fri'],
          allDay: false,
          openingTime: '09:00:00',
          closingTime: '16:30:00'
         }
      ,
      contact: [],
      telecom: [ 
        {system: "email", value: "unimed-vale@gmail.com", use: "work" },
        {system: "phone", value: "250788841494", use: "work" }
      ]
    },
    {
      organization_id: Math.floor(Math.random() * 1000) + 1,
      name: "Unimed Florianópolis",
      alias: "Unimed Florianópolis",
      identifier: [ 
        {system: "CNPJ", value: "774747477-1000"},
      ],
      active: true,
      position: { altitude: 0.04, latitude: 2.25475478, longitude: -83.6945691  },
      hoursOfOperation: 
        { 
          daysOfWeek: ['mon', 'tue', 'fri'],
          allDay: false,
          openingTime: '09:00:00',
          closingTime: '16:30:00'
         }
      ,
      telecom: [ 
        {system: "email", value: "unimed-floripa@gmail.com", use: "work" },
        {system: "phone", value: "250788841494", use: "work" }
      ],
      contact: [],
    },
    {
      organization_id: Math.floor(Math.random() * 1000) + 1,
      name: "Unimed Curitiba",
      alias: "Unimed Curitiba",
      identifier: [ 
        {system: "CNPJ", value: "774747477-1000"},
      ],
      active: true,
      position: { altitude: 0.04, latitude: 2.25475478, longitude: -83.6945691  },
      hoursOfOperation: 
        { 
          daysOfWeek: ['mon', 'tue', 'fri'],
          allDay: false,
          openingTime: '09:00:00',
          closingTime: '16:30:00'
         }
      ,
      contact: [],
      telecom: [ 
        {system: "email", value: "unimed-curitiba@gmail.com", use: "work" },
        {system: "phone", value: "250788841494", use: "work" }
      ]
    }  
  ];

export const proceduresMock: procedureI[] = [{
    id: 1,
    name: 'Endoscopia',
    duration: 30,
    active: true,
    organization: organizationMock[0],
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    orientations: '<p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
    schedules: [],
    paymentMethods: [],
    initialValue: '300,00',
    finalValue: '1500',
    value: '600,00'
},
{
    id: 2,
    name: 'Ultrassom',
    duration: 30,
    active: true,
    organization: organizationMock[0],
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    orientations: '<p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
    schedules: [],
    paymentMethods: [],
    initialValue: '200,00',
    finalValue: '1000,00',
    value: '250,00'
},
{
  id: 3,
  name: 'Radiografia',
  duration: 30,
  active: false,
  organization: organizationMock[0],
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  orientations: '<p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p> <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
  schedules: [],
  paymentMethods: [],
  initialValue: '250,00',
  finalValue: '800',
  value: '400,00'
}
];

export const specialtysSelectMock: filterI[] = [
  { 
    id: 1,
    name: 'Endoscopia',  
  },
  {
    id: 2,
    name: 'Ultrassom'
  }
];

export const citysSelectMock: filterI[] = [
  { 
    id: 1,
    name: 'Blumenau',  
  },
  {
    id: 2,
    name: 'Itajaí'
  }
];

export const practitionersSelectMock: filterPractitionerI[] = [
  { 
    id: 1,
    name: 'Tiberio',  
    cityId: 1,
    specialtyId: 1
  },
  {
    id: 2,
    name: 'Ailton',
    cityId: 2,
    specialtyId: 2
  },
  { 
    id: 3,
    name: 'Julia',  
    cityId: 1,
    specialtyId: 2
  },
  {
    id: 4,
    name: 'Betina',
    cityId: 2,
    specialtyId: 1
  }
];

export const secretariesMock: secretaryI[] = [
  {
    id: "24d4e53a-04a7-435d-b06d-302d84c1786f",
    name: 'Capitu Oliveira',
    birthDate: '07-06-1984',
    cpf: '726.143.580-53',
    gender: 'Female',
    address: [addressMock[0]],
    mail: 'secretary1@gmail.com',
    active: true,
    avatar: '/assets/fotos/secretaria-1.png',
    communication: [],
    qualification: [ qualifications[0], qualifications[1] ],
    certificates: [ courses[0], courses[1] ],
    languages: [ languages[0], languages[1] ],
    practitioners: practitionersMock.map((x:practitionerI) => x.id as number) 
  },
  {
    id: 2,
    name: 'Secretary 2',
    birthDate: '18-02-1996',
    cpf: '096.380.220-86',
    gender: 'Male',
    avatar: '/assets/fotos/secretaria-4.png',
    address: [addressMock[1]],
    mail: 'secretary2@gmail.com',
    active: false,
    communication: [],
    qualification: [ qualifications[0], qualifications[1] ],
    certificates: [ courses[0], courses[1] ],
    languages: [ languages[0], languages[1] ],
    practitioners: [practitionersMock[1].id as number]
  },
  {
    id: 3,
    name: 'Secretary 3',
    birthDate: '18-02-1996',
    cpf: '405.488.860-75',
    gender: 'Female',
    avatar: '/assets/fotos/secretaria-2.jpg',
    address: [addressMock[2]],
    mail: 'secretary3@gmail.com',
    active: true,
    qualification: [ qualifications[0], qualifications[1] ],
    certificates: [ courses[0], courses[1] ],
    languages: [ languages[0], languages[1] ],
    communication: [],
    practitioners: [practitionersMock[2].id as number]
  },
  {
    id: 4,
    name: 'Secretary 4',
    birthDate: '18-02-1956',
    cpf: '405.488.860-75',
    gender: 'Female',
    avatar: '/assets/fotos/secretaria-5.jpg',
    address: [addressMock[3]],
    mail: 'secretary4@gmail.com',
    active: true,
    qualification: [ qualifications[0], qualifications[1] ],
    communication: [],
    certificates: [ courses[0], courses[1] ],
    languages: [ languages[0], languages[1] ],
    practitioners: [practitionersMock[2].id as number]
  }
];

export const patientsMock: patientI[] = [
  {
    id: "f80cddf3-df29-4194-a75d-d6528eb1883d",
    name: 'basas',
    identifier: [
      {
        "system": "CPF",
        "value": "726143580-53"
      }
    ],
    birthDate: '07-06-1984',
    cpf: '72614358053',
    gender: 'Female',
    avatar: '/assets/fotos/paciente-2.png',
    address: {cep: '89010015', district: 'Centro', street: 'Alameda Rio Branco',
              city: 'Blumenau', complement: 'apto. 120', state: 'SC', number: '50', country: 'Brasil',
              latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
    mail: 'julia@gmail.com',
    mobile: '87988323061',
    phone: '3876-2024',
    active: true,
    token_id: "123"
  },
  {
    id: 2,
    name: 'Schasta',
    identifier: [
      {
        "system": "CPF",
        "value": "096380220-86"
      }
    ],
    birthDate: '18-02-1996',
    cpf: '09638022086',
    gender: 'Female',
    avatar: '/assets/fotos/paciente-3.jpg',
    address: {cep: '89070090', district: 'Centro', street: 'Rua Adolf Puff ',
              city: 'Blumenau', complement: 'casa', state: 'SC', number: '80', country: 'Brasil',
              latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
    mail: 'schasta@gmail.com',
    mobile: '87988323061',
    phone: '3876-2024',
    active: false,
    token_id: "456"
  },
  {
    id: 3,
    name: 'Rafael',
    identifier: [
      {
        "system": "CPF",
        "value": "405.488.860-75"
      }
    ],
    birthDate: '18-04-1990',
    cpf: '405.488.860-75',
    gender: 'Male',
    avatar: '/assets/fotos/paciente-1.png',
    address: {cep: '89070090', district: 'Centro', street: 'Rua Adolf Puff ',
              city: 'Blumenau', complement: 'casa', state: 'SC', number: '80', country: 'Brasil',
              latitude: '-27.553777779913904', longitude: '-48.498534066204435' },
    mail: 'rafael@gmail.com',
    mobile: '87988323061',
    phone: '3876-2024',
    active: true,
    token_id: "789"
  }
];

export const scheduleData:scheduleI[] = [{
  id: 1,
  type: 'Consulta',
  practioner: practitionersMock[1],
  patient: patientsMock[2],
  dateStart: moment().set("hour", 9).set("minute", 30).format('YYYY-MM-DD HH:mm'),
  dateEnd: moment().set("hour", 9).set("minute", 30).format('YYYY-MM-DD HH:mm'),
  status: "planned",
  organization: organizationMock[0].id as number,
  active: true
},
{
  id: 2,
  type: 'Exame',
  practioner: practitionersMock[2],
  procedure: proceduresMock[2],
  patient: patientsMock[1],
  dateStart: moment().set("hour", 10).set("minute", 0).format('YYYY-MM-DD HH:mm'),
  organization: organizationMock[0].id as number,
  status: "planned",
  active: true
},
{
  id: 3,
  type: 'Exame',
  practioner: practitionersMock[3],
  procedure: proceduresMock[1],
  patient:  patientsMock[1],
  dateStart: moment().set("hour", 11).set("minute", 0).format('YYYY-MM-DD HH:mm'),
  organization: organizationMock[1].id as number,
  status: "planned",
  active: true
},
{
  id: 4,
  type: 'Consulta',
  practioner: practitionersMock[1],
  patient: patientsMock[3],
  dateStart: moment().add(1,'day').set("hour", 9).set("minute", 30).format('YYYY-MM-DD HH:mm'),
  dateEnd: moment().add(1,'day').set("hour", 9).set("minute", 30).format('YYYY-MM-DD HH:mm'),
  status: "planned",
  organization: organizationMock[0].id as number,
  active: true
},
{
  id: 5,
  type: 'Exame',
  practioner: practitionersMock[2],
  procedure: proceduresMock[1],
  patient: patientsMock[2],
  dateStart: moment().add(2,'day').set("hour", 10).set("minute", 0).format('YYYY-MM-DD HH:mm'),
  organization:  organizationMock[0].id as number,
  status: "planned",
  active: true
},
{
  id: 6,
  type: 'Exame',
  practioner: practitionersMock[2],
  procedure: proceduresMock[1],
  patient: patientsMock[2],
  dateStart: moment().add(1,'day').set("hour", 11).set("minute", 0).format('YYYY-MM-DD HH:mm'),
  organization: organizationMock[0].id as number,
  status: "planned",
  active: true
}];

export const calendarMock: CalendarEvent[] =
[
  {
    start: moment().toDate(),
    end: moment().add(1, 'hours').toDate(),
    title: '<b>Consulta</b> | <b>Especialista:</b> Ailton | <b>Paciente:</b> Julia',
    color: { ...cardColors['blue'] },
    actions: undefined,
    allDay: false,
    resizable: {
      beforeStart: true,
      afterEnd: true,
    },
    draggable: false,
  },
  {
    start: moment().add(1, 'hours').toDate(),
    end: moment().add(2, 'hours').toDate(),
    title: '<b>Exame</b> | <b>Procedimento:</b> Ultrassom | <b>Paciente:</b> Schasta',
    color: { ...cardColors['yellow'] },
    actions: undefined,
  },
  {
    start: moment().add(2, 'hours').toDate(),
    end: moment().add(3, 'hours').toDate(),
    title: '<b>Consulta</b> | <b>Especialista:</b> Tiberio | <b>Paciente:</b> Julia',
    color: { ...cardColors['blue'] },
    allDay: false,
  },
  {
    start: moment().add(2, 'hours').toDate(),
    end: moment().add(3, 'hours').toDate(),
    title: '<b>Exame</b> | <b>Procedimento:</b> Endoscopia | <b>Paciente:</b> Schasta',
    color: { ...cardColors['yellow'] },
    actions: undefined,
    resizable: {
      beforeStart: true,
      afterEnd: true,
    },
    draggable: false,
  },
  {
    start: moment().add(2, 'day').toDate(),
    end: moment().add(3, 'hours').toDate(),
    title: '<b>Exame</b> | <b>Procedimento:</b> Endoscopia | <b>Paciente:</b> Schasta',
    color: { ...cardColors['yellow'] },
    actions: undefined,
    resizable: {
      beforeStart: true,
      afterEnd: true,
    },
    draggable: false,
  },
 
]



export const prescriptionsMock: prescriptionI[] = [
  {
    id: 1,
    patient: patientsMock[0],
    date: moment().subtract(2,'days').format('YYYY-MM-DD'),
    practitioner: practitionersMock[0],
    description: 'Mauris gravida lorem libero, quis sodales felis accumsan sed. Vestibulum eleifend ante enim, eu cursus odio elementum a. <br>Ut hendrerit sem a leo volutpat volutpat. Cras et laoreet ante, vel bibendum odio. Vestibulum imperdiet lorem a lacinia condimentum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Phasellus massa metus, varius ac fringilla feugiat, suscipit eu ante. Aenean et magna sit amet justo euismod vehicula. Etiam semper efficitur sem vitae hendrerit. <br> Nulla ut gravida magna, at convallis purus.'
  },
  {
    id: 2,
    patient: patientsMock[0],
    date: moment().subtract(1,'days').format('YYYY-MM-DD'),
    practitioner: practitionersMock[0],
    description: 'In quis risus efficitur, rhoncus urna venenatis, sagittis ex. Fusce laoreet magna quis orci bibendum, molestie lacinia neque pulvinar. Morbi tempor ante mi, vitae fringilla sapien porttitor ac. Suspendisse quis massa sodales, consequat nulla eu, convallis est. <br> Quisque et nulla eget mi porta ornare non ut leo. Morbi non tellus non ipsum hendrerit pharetra a non lacus. <br>Etiam dapibus in nunc ut fermentum.'
  },
  {
    id: 2,
    patient: patientsMock[0],
    date: moment().subtract(1,'days').format('YYYY-MM-DD'),
    practitioner: practitionersMock[0],
    description: 'Curabitur sit amet justo lacus. <br>Nullam congue arcu sed elit consectetur congue.<br> Suspendisse ut quam sed libero egestas vulputate eu sed libero. Curabitur vitae massa eget erat ornare viverra et vel tortor. <br> Maecenas congue at velit et accumsan. Sed eget leo eget purus vestibulum porta. Phasellus ut posuere nibh. Sed hendrerit, lorem et faucibus consectetur, dolor purus hendrerit ligula, vel venenatis ante urna eu nibh. Cras ultricies turpis et felis accumsan, non aliquet diam fringilla. Sed rhoncus elit sapien, quis vehicula nisi tincidunt nec. <br> Nam accumsan nulla lorem, eget volutpat nibh hendrerit quis.'
  }
];
